// src/routes/AppRoutes.js

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "../Layout";

/* WEBSITE PAGES */
import HeroSection from "../Pages/home/HeroSection";
import Challenges from "../Pages/challenges/Challenges";
import Contact from "../Pages/contact/Contact";
import Community from "../Pages/community/Community";

/* LEGAL / POLICY PAGES */
import PrivacyPolicyPage from "../Components/Policy/PrivacyPolicy";
import TermsAndConditionsPage from "../Components/terms/TermsAndConditions";

/* AUTH PAGES */
import Login from "../Pages/login/Login";
import ForgetPassword from "../Pages/forget-password/ForgetPassword";
import ResetPassword from "../Pages/reset-password/ResetPassword";
import VerifyEmail from "../Pages/verify-email/VerifyEmail";
import SignUp from "../Pages/signup/SignUp";

/* DASHBOARD PAGES */
import Profile from "../Pages/profile/Profile";
import DashboardLayout from "../layout/DashboardLayout";
import ChallengeDetails from "../Pages/challenges/ChallangesDetails";
import Favourite from "../Pages/challenges/favourite";
import Dashboard from "../Pages/dashboard/Dashboard";

import ContactInfo from "../Pages/contact-info/ContactInfo";
import TermsConditions from "../Pages/contact-info/TermsConditions";
import PrivacyPolicy from "../Pages/contact-info/PrivacyPolicy";
import AboutUs from "../Pages/contact-info/AboutUs";
import Faqs from "../Pages/contact-info/Faqs";

/* TEAM MANAGEMENT */
import TeamManagement from "../Pages/team-management/TeamManagement";
import TeamDetails from "../Pages/team-management/TeamDetails";
import CreateGroup from "../Pages/team-management/CreateGroup";
import EditGroup from "../Pages/team-management/EditGroup";

/* Payment Order */
import Payment from "../Pages/payment_order/Payment";
import AllChallenges from "../Pages/all-challenges/AllChallenges";
import AddDistance from "../Pages/all-challenges/AddDistance";
import MissionDetails from "../Pages/all-challenges/MissionDetails";
import ChallengeManagement from "../Pages/challenge-management/ChallengeManagement";
import ChallengeManagementDetails from "../Pages/challenge-management/ChallengeManagementDetails";
import Rewards from "../Pages/rewards/Rewards";
import RewardsPostcards from "../Pages/rewards/RewardsPostcards";
import NotificationsPage from "../Pages/notifications/NotificationsPage";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* ROOT REDIRECT */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* WEBSITE ROUTES */}
        <Route
          path="/home"
          element={
            <Layout>
              <HeroSection />
            </Layout>
          }
        />

        <Route
          path="/challenges"
          element={
            <Layout>
              <Challenges />
            </Layout>
          }
        />

        <Route
          path="/challenges/view/:id"
          element={
            <Layout>
              <ChallengeDetails />
            </Layout>
          }
        />

        <Route
          path="/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />

        <Route
          path="/community"
          element={
            <Layout>
              <Community />
            </Layout>
          }
        />

        {/* FOOTER / PUBLIC POLICY ROUTES */}
        <Route
          path="/privacy-policy"
          element={
            <Layout>
              <PrivacyPolicyPage />
            </Layout>
          }
        />

        <Route
          path="/terms-and-conditions"
          element={
            <Layout>
              <TermsAndConditionsPage />
            </Layout>
          }
        />

        {/* AUTH ROUTES */}
        <Route path="/login" element={<Login />} />

        <Route path="/create-account" element={<SignUp />} />

        <Route path="/forget-password" element={<ForgetPassword />} />

        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/verify-email" element={<VerifyEmail />} />

        <Route path="/signup" element={<SignUp />} />

        {/* DASHBOARD ROUTES */}
        <Route
          element={
            <Layout>
              <DashboardLayout />
            </Layout>
          }
        >
          <Route path="/profile" element={<Profile />} />
          <Route path="/favourites" element={<Favourite />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/team-management" element={<TeamManagement />} />
          <Route path="/team-management/:id" element={<TeamDetails />} />
          <Route
            path="/team-management/challenge/:id"
            element={<TeamManagement />}
          />
          <Route
            path="/team-management/create-group"
            element={<CreateGroup />}
          />
          <Route
            path="/team-management/edit-group/:id"
            element={<EditGroup />}
          />
          {/* CONTACT INFO */}
          <Route path="/contact-info" element={<ContactInfo />} />
          <Route
            path="/contact-info/terms-conditions"
            element={<TermsConditions />}
          />
          <Route
            path="/contact-info/privacy-policy"
            element={<PrivacyPolicy />}
          />
          <Route path="/contact-info/about-us" element={<AboutUs />} />
          <Route path="/contact-info/faqs" element={<Faqs />} />
          {/* Payment Order */}
          <Route path="/payments" element={<Payment />} />
          <Route path="/all-challenges" element={<AllChallenges />} />
          <Route
            path="/all-challenges/add-distance/:id"
            element={<AddDistance />}
          />
          <Route
            path="/all-challenges/mission/:id"
            element={<MissionDetails />}
          />
          <Route
            path="/challenge-management"
            element={<ChallengeManagement />}
          />
          <Route
            path="/challenge-management/:id"
            element={<ChallengeManagementDetails />}
          />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/rewards/:id" element={<RewardsPostcards />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;